/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEmergencyContactRequestDto } from '../models';
// @ts-ignore
import type { EmergencyContactDto } from '../models';
// @ts-ignore
import type { EmergencyContactIdDto } from '../models';
// @ts-ignore
import type { EmergencyContactSearchRequestDto } from '../models';
// @ts-ignore
import type { EmergencyContactSearchResponseDto } from '../models';
// @ts-ignore
import type { UpdateEmergencyContactRequestDto } from '../models';
/**
 * RestEmergencyContactsApi - axios parameter creator
 */
export const RestEmergencyContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEmergencyContactRequestDto} createEmergencyContactRequestDto Create emergency contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmergencyContact: async (createEmergencyContactRequestDto: CreateEmergencyContactRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmergencyContactRequestDto' is not null or undefined
            assertParamExists('createEmergencyContact', 'createEmergencyContactRequestDto', createEmergencyContactRequestDto)
            const localVarPath = `/api/emergency-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmergencyContactRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} emergencyContactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmergencyContact: async (emergencyContactId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emergencyContactId' is not null or undefined
            assertParamExists('getEmergencyContact', 'emergencyContactId', emergencyContactId)
            const localVarPath = `/api/emergency-contacts/{emergencyContactId}`
                .replace('{emergencyContactId}', encodeURIComponent(String(emergencyContactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of emergency contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {EmergencyContactSearchRequestDto} emergencyContactSearchRequestDto Emergency contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmergencyContacts: async (page: number, pageSize: number, emergencyContactSearchRequestDto: EmergencyContactSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchEmergencyContacts', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchEmergencyContacts', 'pageSize', pageSize)
            // verify required parameter 'emergencyContactSearchRequestDto' is not null or undefined
            assertParamExists('searchEmergencyContacts', 'emergencyContactSearchRequestDto', emergencyContactSearchRequestDto)
            const localVarPath = `/api/emergency-contacts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emergencyContactSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} emergencyContactId 
         * @param {UpdateEmergencyContactRequestDto} updateEmergencyContactRequestDto Update emergency contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmergencyContact: async (emergencyContactId: number, updateEmergencyContactRequestDto: UpdateEmergencyContactRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emergencyContactId' is not null or undefined
            assertParamExists('updateEmergencyContact', 'emergencyContactId', emergencyContactId)
            // verify required parameter 'updateEmergencyContactRequestDto' is not null or undefined
            assertParamExists('updateEmergencyContact', 'updateEmergencyContactRequestDto', updateEmergencyContactRequestDto)
            const localVarPath = `/api/emergency-contacts/{emergencyContactId}`
                .replace('{emergencyContactId}', encodeURIComponent(String(emergencyContactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmergencyContactRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestEmergencyContactsApi - functional programming interface
 */
export const RestEmergencyContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestEmergencyContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEmergencyContactRequestDto} createEmergencyContactRequestDto Create emergency contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmergencyContact(createEmergencyContactRequestDto: CreateEmergencyContactRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmergencyContact(createEmergencyContactRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmergencyContactsApi.createEmergencyContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} emergencyContactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmergencyContact(emergencyContactId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmergencyContact(emergencyContactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmergencyContactsApi.getEmergencyContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of emergency contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {EmergencyContactSearchRequestDto} emergencyContactSearchRequestDto Emergency contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEmergencyContacts(page: number, pageSize: number, emergencyContactSearchRequestDto: EmergencyContactSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEmergencyContacts(page, pageSize, emergencyContactSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmergencyContactsApi.searchEmergencyContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} emergencyContactId 
         * @param {UpdateEmergencyContactRequestDto} updateEmergencyContactRequestDto Update emergency contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmergencyContact(emergencyContactId: number, updateEmergencyContactRequestDto: UpdateEmergencyContactRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmergencyContact(emergencyContactId, updateEmergencyContactRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestEmergencyContactsApi.updateEmergencyContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestEmergencyContactsApi - factory interface
 */
export const RestEmergencyContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestEmergencyContactsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEmergencyContactRequestDto} createEmergencyContactRequestDto Create emergency contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmergencyContact(createEmergencyContactRequestDto: CreateEmergencyContactRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmergencyContactIdDto> {
            return localVarFp.createEmergencyContact(createEmergencyContactRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} emergencyContactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmergencyContact(emergencyContactId: number, options?: RawAxiosRequestConfig): AxiosPromise<EmergencyContactDto> {
            return localVarFp.getEmergencyContact(emergencyContactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of emergency contacts
         * @param {number} page 
         * @param {number} pageSize 
         * @param {EmergencyContactSearchRequestDto} emergencyContactSearchRequestDto Emergency contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmergencyContacts(page: number, pageSize: number, emergencyContactSearchRequestDto: EmergencyContactSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmergencyContactSearchResponseDto> {
            return localVarFp.searchEmergencyContacts(page, pageSize, emergencyContactSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} emergencyContactId 
         * @param {UpdateEmergencyContactRequestDto} updateEmergencyContactRequestDto Update emergency contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmergencyContact(emergencyContactId: number, updateEmergencyContactRequestDto: UpdateEmergencyContactRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmergencyContact(emergencyContactId, updateEmergencyContactRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestEmergencyContactsApi - interface
 */
export interface RestEmergencyContactsApiInterface {
    /**
     * 
     * @param {CreateEmergencyContactRequestDto} createEmergencyContactRequestDto Create emergency contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmergencyContact(createEmergencyContactRequestDto: CreateEmergencyContactRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmergencyContactIdDto>;

    /**
     * 
     * @param {number} emergencyContactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmergencyContact(emergencyContactId: number, options?: RawAxiosRequestConfig): AxiosPromise<EmergencyContactDto>;

    /**
     * 
     * @summary Get list of emergency contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {EmergencyContactSearchRequestDto} emergencyContactSearchRequestDto Emergency contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchEmergencyContacts(page: number, pageSize: number, emergencyContactSearchRequestDto: EmergencyContactSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmergencyContactSearchResponseDto>;

    /**
     * 
     * @param {number} emergencyContactId 
     * @param {UpdateEmergencyContactRequestDto} updateEmergencyContactRequestDto Update emergency contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmergencyContact(emergencyContactId: number, updateEmergencyContactRequestDto: UpdateEmergencyContactRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestEmergencyContactsApi - object-oriented interface
 */
export class RestEmergencyContactsApi extends BaseAPI implements RestEmergencyContactsApiInterface {
    /**
     * 
     * @param {CreateEmergencyContactRequestDto} createEmergencyContactRequestDto Create emergency contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEmergencyContact(createEmergencyContactRequestDto: CreateEmergencyContactRequestDto, options?: RawAxiosRequestConfig) {
        return RestEmergencyContactsApiFp(this.configuration).createEmergencyContact(createEmergencyContactRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} emergencyContactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmergencyContact(emergencyContactId: number, options?: RawAxiosRequestConfig) {
        return RestEmergencyContactsApiFp(this.configuration).getEmergencyContact(emergencyContactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of emergency contacts
     * @param {number} page 
     * @param {number} pageSize 
     * @param {EmergencyContactSearchRequestDto} emergencyContactSearchRequestDto Emergency contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchEmergencyContacts(page: number, pageSize: number, emergencyContactSearchRequestDto: EmergencyContactSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestEmergencyContactsApiFp(this.configuration).searchEmergencyContacts(page, pageSize, emergencyContactSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} emergencyContactId 
     * @param {UpdateEmergencyContactRequestDto} updateEmergencyContactRequestDto Update emergency contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEmergencyContact(emergencyContactId: number, updateEmergencyContactRequestDto: UpdateEmergencyContactRequestDto, options?: RawAxiosRequestConfig) {
        return RestEmergencyContactsApiFp(this.configuration).updateEmergencyContact(emergencyContactId, updateEmergencyContactRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

